<template>
    <div>
        <Head :title="__(title)" />
        <div v-if="!print_preview" class="md:mt-12 sm:mt-3 justify-center flex">
            <form class="input-box pb-11 flex flex-col justify-center items-center sm:w-full md:w-[32rem]" @submit.prevent="setCard">
                <span class="top-bar" />
                <h3 class="mt-5 text-2xl font-semibold">{{ __('Student Name QR Code Generator') }}</h3>
                <text-input v-model="form.school_name" :error="form.errors.school_name" class=" w-3/4 mt-10" :label="__('School Name')" placeholder="Type Your School Name (Optional)" type="text" autofocus autocapitalize="off" :is_required="false" />
                <loading-button :loading="form.processing" class="w-3/4 mt-5 btn generate" type="button" @click="fileBrowseSchoolLogo">{{ form.school_logo? __('Logo Added') : __('Add School Logo') }}</loading-button>
                <text-input v-model="form.student_name" :error="form.errors.student_name" class=" w-3/4 mt-5" :label="__('Student Name')" placeholder="Type Your Name" type="text" autofocus autocapitalize="off" :is_required="true" required />
                <loading-button :loading="form.processing" class="w-3/4 mt-5 btn generate" type="submit">{{ __('Generate') }}</loading-button>
                <div class="flex justify-center items-center gap-2 w-3/4 mt-5 hr_or"> <hr /> OR <hr /> </div>
                <loading-button :loading="form.processing" class="w-3/4 mt-5 btn generate" type="button" @click="fileBrowse">{{ __('Bulk Create') }}</loading-button>
                <!-- New Code -->
                <input id="file" ref="file" type="file" :accept="file_accept" class="hidden" @change="fileInputChange" />
                <input id="schoolLogo" ref="schoolLogo" type="file" accept="image/png,image/jpeg,image/jpg,image/svg" class="hidden" @change="schoolLogoInputChange" />
                <!-- New Code -->
                <div class="inline-flex justify-start items-center w-3/4 mt-5">
                    <input v-model="form.with_photos" type="checkbox" name="with_photos" class="form-checkbox h-5 w-5 mr-2 text-gray-600" @change="withPhotosCheck"> {{ __('With Photos') }} ({{__('Suggested photo size: 200 * 200. The file cannot be larger than 1MB')}})
                </div>
                <div class="flex justify-end text-right w-3/4 mt-2"><a href="https://youtu.be/SbhnEJp53Ug" target="_blank">*{{ __('How to use') }}</a></div>
            </form>
        </div>
        <div v-if="print_preview" class="md:mt-8 sm:mt-3 justify-center p_card">
            <div v-for="(cardPage, cpi) in cardPages" :key="cpi" class="grid auto-cols-auto auto-rows-[244px] items-center justify-center w-full a4__card" :class="{'pageBreak':cpi > 0}">
                <div v-for="(card, ci) in cardPage" :key="ci" class="card__entry">
                    <div class="flex flex-col justify-between id_card">
                        <div class="flex justify-between main__content">
                            <div class="flex flex-col w-3/5 photo_name">
                                <div class="flex justify-center items-center p__photo">
                                    <img v-if="card.photo" class="p__image" :src="card.photo" />
                                    <img v-else class="p__image" src="/images/card/card_photo.png" />
                                </div>
                                <div class="school_name">{{ card.school_name }}</div>
                                <div class="student_name">{{ card.student_name }}</div>
                            </div>
                            <div class="w-2/5 flex justify-end qr_code">
                                <img class="p__image" v-if="card.image"  :src="card.image" />
                            </div>
                        </div>
                        <!--                        <div class="w-full flex justify-between items-center gap-[8%] bottom__content">-->
                        <!--                            <div class="flex w-2/3 bar"></div>-->
                        <!--                            <div class="flex justify-center items-center w-1/3 gap-1.5 credit">-->
                        <!--                                <span class="c__text">Powered by</span>-->
                        <!--                                <img class="c__logo" src="/images/card/c__logo.svg" />-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                    </div>
                </div>
            </div>
            <div class="print_btn_wrap">
                <div class="flex btn generate print items-center print_now" onclick="window.print()"> Print A4 </div>
            </div>
            <div class="footer_area mt-8 flex justify-between">
                <span class="version">Version 1.1.0</span>
                <span class="btn_policy">Policy</span>
            </div>
        </div>
        <!-- Loading Process -->
        <div v-if="form.processing" class="processing-overlay">
            <div class="background"></div>
            <div class="loader">
                <svg width="200px" height="200px"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" style="background: none;">
                    <circle cx="75" cy="50" fill="#ffffff" r="6.39718">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.875s"></animate>
                    </circle>
                    <circle cx="67.678" cy="67.678" fill="#ffffff" r="4.8">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.75s"></animate>
                    </circle>
                    <circle cx="50" cy="75" fill="#ffffff" r="4.8">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.625s"></animate>
                    </circle>
                    <circle cx="32.322" cy="67.678" fill="#ffffff" r="4.8">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5s"></animate>
                    </circle>
                    <circle cx="25" cy="50" fill="#ffffff" r="4.8">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.375s"></animate>
                    </circle>
                    <circle cx="32.322" cy="32.322" fill="#ffffff" r="4.80282">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.25s"></animate>
                    </circle>
                    <circle cx="50" cy="25" fill="#ffffff" r="6.40282">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.125s"></animate>
                    </circle>
                    <circle cx="67.678" cy="32.322" fill="#ffffff" r="7.99718">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="0s"></animate>
                    </circle>
                </svg>
            </div>
        </div>
        <!-- Loading Process -->
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Icon from '@/Shared/Icon';
import {Link, Head} from '@inertiajs/inertia-vue3'

export default {
    layout: Layout,
    components: {
        Logo,
        Icon,
        LoadingButton,
        SelectInput,
        TextInput,
        Link, Head
    },
    props: {
        title: String,
    },
    remember: 'form',
    data() {
        return {
            file_accept: '.csv',
            form: this.$inertia.form({
                school_name: '',
                student_name: '',
                image: '',
                cards: [],
                processing: false,
                with_photos: false,
                school_logo: null,
            }),
            cardPages: [],
            print_preview: false,
        }
    },
    created() {
        this.resetForm()
    },
    methods: {
        resetForm(){
            this.file_accept = '.csv'
            this.form.school_name = ''
            this.form.student_name = ''
            this.form.image = ''
            this.form.cards = []
            this.form.processing = false
            this.form.with_photos = false
            this.cardPages = []
            this.print_preview = false
            this.form.school_logo = null
        },
        printSectionReady(){
            this.print_preview = true;
            this.cardPages = this.partitionArray(this.form.cards, 6)
            this.form.processing = false
        },
        partitionArray(array, size){
            return array.map( (e,i) => (i % size === 0)     ? array.slice(i, i + size)     : null   )   .filter( (e) => e )
        },
        withPhotosCheck(){
            if(!!this.form.with_photos){
                this.file_accept = '.zip'
            }
        },
        schoolLogoInputChange(e){
            if(e.target.files.length && e.target.files[0]){
                this.form.processing = true
                let data = new FormData()
                data.append('school_logo', document.getElementById('schoolLogo').files[0]);
                this.axios.post(this.route('upload.school_logo'), data).then(( response ) => {
                    if(response.data && response.data.school_logo){
                        this.form.school_logo = response.data.school_logo
                        this.form.processing = false
                        console.log(this.form)
                    }else{
                        alert('something went wrong!')
                        this.form.processing = false
                    }
                }).catch((error) => {
                    this.form.processing = false
                    console.log(error)
                })
            }
        },
        fileInputChange(e) {
            this.form.processing = true
            let data = new FormData()
            const fileSel = document.getElementById('file')
            if(fileSel.files.length && fileSel.files[0]){
                data.append('with_photos', this.form.with_photos ? 'yes' : 'no')
                data.append('school_name', this.form.school_name)
                data.append('school_logo', this.form.school_logo)
                data.append('file', document.getElementById('file').files[0]);
                this.axios.post(this.route('import.file'), data).then(( response ) => {
                    if(response.data && response.data.file_data && response.data.file_data.length){
                        this.setCardWithFileData(response.data.file_data)
                    }else{
                        alert('something went wrong!')
                        this.form.processing = false
                    }
                }).catch((error) => {
                    this.form.processing = false
                    console.log(error)
                })
            }
        },
        setCard(){
            this.form.processing = true
            for (let step = 0; step < 6; step++) {
                this.form.cards.push( { school_name: this.form.school_name, student_name: this.form.student_name } )
            }
            const student_data = this.form.cards.map( (c) => {return {name: c.student_name, school: c.school_name, logo: this.form.school_logo}} );
            this.createQr(student_data);
        },
        setCardWithFileData(data){
            this.form.cards.splice(0, this.form.cards.length, ...data)
            const student_data = this.form.cards.map( (c) => {return {name: c.student_name, school: c.school_name, logo: c.school_logo}} );
            this.createQr(student_data);
        },
        createQr(student_data){
            this.axios.post(this.route('create.qr'), { student_data: student_data }).then((response) => {
                if(response.data && response.data.images && response.data.images.length && this.form.cards.length === response.data.images.length){
                    for (let index = 0; index < this.form.cards.length; index++) {
                        this.form.cards[index].image = response.data.images[index]
                    }
                    this.printSectionReady()
                }
            }).catch((error) => {
                console.log(error)
                this.form.processing = false
            })
        },
        fileBrowse() {
            this.$refs.file.click()
        },
        fileBrowseSchoolLogo() {
            this.$refs.schoolLogo.click()
        },
    },
}
</script>




